import { dataHooks } from '@wix/data-hooks';

export const subHeaderWithSearchDataHooks = dataHooks<{
  subtitle: {};
  title: {};
  description: {};
  signupLink: {};
}>('sub-header-with-search');
